import React from 'react';
import { FlameIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="section-dramatic py-24 px-4 border-y border-navy-800" data-id="element-132">
      {/* Dramatic Background */}
      <div className="flag-bg opacity-20" data-id="element-133"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/80 to-navy-950/90 z-0 pointer-events-none" data-id="element-134"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[500px] bg-patriot-red/10 blur-[150px] rounded-full pointer-events-none z-0" data-id="element-135"></div>

      {/* Crowd Silhouette */}
      <div className="crowd-bottom opacity-60" data-id="element-136"></div>

      <div className="max-w-4xl mx-auto text-center space-y-8 relative z-10" data-id="element-137">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 text-sm font-bold tracking-widest text-white border border-patriot-red/50 bg-patriot-red/20 uppercase rounded-full backdrop-blur-md shadow-[0_0_15px_rgba(178,34,52,0.2)]" data-id="element-138">
          PROPRIETARY FRAMEWORK
        </div>

        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-navy-900/80 border border-patriot-red/50 shadow-[0_0_40px_rgba(178,34,52,0.3)] backdrop-blur-sm" data-id="element-139">
          <FlameIcon className="w-10 h-10 text-patriot-red" data-id="element-140" />
        </div>

        <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white text-shadow-md" data-id="element-141">
          The Legacy of the <br data-id="element-142" />
          <span className="text-transparent bg-clip-text bg-red-gradient text-shadow-red" data-id="element-143">
            Unbreakable Voice
          </span>
        </h2>

        <div className="glass-card p-8 md:p-12 rounded-2xl mx-auto text-slate-200 leading-relaxed text-lg md:text-xl shadow-2xl border-patriot-red/20" data-id="element-144">
          <p className="mb-6" data-id="element-145">
            This exclusive eBook uses the revolutionary narrative of{' '}
            <strong className="text-white font-bold border-b-2 border-patriot-red" data-id="element-146">
              "Predictive History"
            </strong>{' '}
            to expose you to reality without filters. It's not a boring
            political analysis; it's a direct transfer of courage and strategic
            dominance.
          </p>
          <p className="mb-8" data-id="element-147">
            Through the analysis of Kirk's rise, fall, and ideological
            resurrection, we activate in the reader the{' '}
            <strong className="text-white font-bold border-b-2 border-patriot-red" data-id="element-148">
              Muscle of Civil Resistance
            </strong>
            .
          </p>
          <blockquote className="border-l-4 border-patriot-red pl-6 py-2 text-2xl md:text-3xl font-serif text-white italic text-left bg-gradient-to-r from-patriot-red/10 to-transparent" data-id="element-149">
            "You will learn that an idea doesn't die when the leader disappears,
            but when the followers decide to inherit their voice."
          </blockquote>
        </div>
      </div>
    </section>;
}